import React from "react";
import Step from "./Step";
import howItWorks1 from "../images/how-it-works-1.svg";
import howItWorks2 from "../images/how-it-works-2.svg";
import howItWorks3 from "../images/how-it-works-3.svg";
import howItWorks4 from "../images/how-it-works-4.svg";

function HowItWorks() {

  return (
    <div className="py-12 px-4 bg-gray-100">
      <div className="container mx-auto">
        <div className="text-center w-full lg:w-2/3 mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold leading-tight">
            Our simple process
          </h2>
        </div>
        <div className="flex flex-col mt-8 justify-center items-center">
          <Step
            imageSrc={howItWorks1}
            title="Send us your requirements"
            description="You will fill out our Notion Template with your requirements.
              This will allow us to get an idea of your needs, the scope of the project and a rough idea of what the landing page should look like."
          />
          <Step
            imageSrc={howItWorks2}
            title="Intro meeting"
            description="We have a 30 min call to lay out project goals and timelines. We will also touch on Content and Brand strategy. 
              This may need a deeper dive later on. We will quote you a fixed fee for the full project"
          />          
          <Step
            imageSrc={howItWorks3}
            title="We build your landing page"
            description="We build out your landing page + any other sections you ordered within 7 days. We will have multiple iterations during this stage to get your 
              feedback and make sure everything is going according to plan."
          />
          <Step
            imageSrc={howItWorks4}
            title="We launch your site"
            description="We deliver you the code as well as a live link to your website. Content and Brand strategy guides may also be included if needed."
          />
        </div>
      </div>
    </div>
  )
}

export default HowItWorks;